import { useState } from 'react'
import { Link } from 'react-router-dom'
import { sendRecoveryEmail } from '../utils/api'

export default function KeyRecovery() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError('Please enter a valid email address')
      return
    }
    setStatus('sending')
    setError('')
    try {
      const result = await sendRecoveryEmail(email.trim().toLowerCase())
      setStatus(result.success ? 'sent' : 'error')
      if (!result.success) setError('Failed to send recovery email. Please try again.')
    } catch {
      setStatus('error')
      setError('Network error. Please check your connection and try again.')
    }
  }

  if (status === 'sent') {
    return (
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="card max-w-md w-full text-center">
          <div className="w-16 h-16 rounded-full bg-[var(--bac-safe)] mx-auto mb-6 flex items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold mb-4">Check your email</h1>
          <p className="text-[var(--text-secondary)] mb-6">
            If a log exists with <strong>{email}</strong>, we've sent your recovery link.
          </p>
          <Link to="/" className="btn btn-primary">
            Return home
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="card max-w-md w-full">
        <h1 className="text-2xl font-bold mb-2 text-center">Recover your key</h1>
        <p className="text-[var(--text-secondary)] text-center mb-6">
          We'll email your log link to your backup address.
        </p>
        <form onSubmit={handleSubmit}>
          <label className="block text-sm text-[var(--text-secondary)] mb-1">Email address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              setError('')
            }}
            placeholder="you@example.com"
            className="w-full mb-4"
            disabled={status === 'sending'}
          />
          {error && <p className="text-sm text-[var(--bac-danger)] mb-4">{error}</p>}
          <button type="submit" disabled={status === 'sending'} className="w-full btn btn-primary">
            {status === 'sending' ? 'Sending…' : 'Send recovery email'}
          </button>
        </form>
        <p className="text-xs text-[var(--text-secondary)] mt-4 text-center">
          This only works if you set a backup email in Settings.{' '}
          <Link to="/" className="text-[var(--accent-teal)] underline">
            Back home
          </Link>
        </p>
      </div>
    </div>
  )
}
